<template>
  <v-app id="switch-shopper">
    <xbox-shopper />
  </v-app>
</template>

<script>
import XboxShopper from './components/XboxShopper';

export default {
  name: 'App',

  components: {
    'xbox-shopper': XboxShopper
  }
};
</script>
